const domid_prefix = (Date.now() + '-').substr(6);
let domid_incr = 0;
export function domid(suffix) {
    return domid_prefix + (domid_incr++) + ':' + (suffix || '').trim();
}

export function arrayToObject(array, keyProp) {
    const object = {};
    for (let i = 0, item; (item = array[i]); i++) {
        object[item[keyProp || i]] = item;
    }
    return object;
}


export function assignSoft(target, source) {
    for (const key in source) {
        if (target[key] !== undefined && source.hasOwnProperty(key)) {
            target[key] = source[key];
        }
    }
    return target;
}


export function updateObject(original, newValues) {
    let clone;
    for (const key in newValues) {
        if (newValues.hasOwnProperty(key)) {
            const val = newValues[key];
            if (original[key] !== val) {
                clone = clone || Object.assign({}, original);
                clone[key] = val;
            }
        }
    }
    return clone || original;
}


// export function mercatorFromPixel (x, y, mapWidth, mapHeight) {
//     mapWidth = mapWidth || mc.$map.width();
//     mapHeight = mapHeight || mc.$map.height();
//     if (x < 0 || y < 0 || x > mapWidth || y > mapHeight) {
//         return null;
//     }
//     const ps = state.forecastData.geo;
//     const lon = ((x / mapWidth) * (ps.e_lon - ps.w_lon) + ps.w_lon);
//     const lat = ((y / mapHeight) * (merc(ps.s_lat) - merc(ps.n_lat)) + merc(ps.n_lat));
//     return [ lat, lon ];
// };


export function mercator(lat) {
    return Math.log(Math.tan(lat * Math.PI / 360 + Math.PI / 4));
}


export function toTimestamp(dateString) {
    return dateString != null ? (new Date(dateString)).getTime() : undefined;
}

export function capitalize(str) {
    return str && str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Round to nearest power of ten.
 * @param {Number} x The number to round
 * @param {int} [e=ee] The number of decimals to show
 * @param {int} [ee=0] Default number of decimals to show
 * */
export function round10(x, e, ee) {
    if (e === undefined) e = ee;
    const s = e ? Math.pow(10, e) : 1;
    // Don't make s=10^-e since that leads to rounding errors.
    return Math.round(x * s) / s;
}

/**
 * Round to nearest multiple of a value.
 * @param {Number} x The number to round
 * @param {Number} [s=1] The number to round to
 * */
export function roundN(x, s) {
    if (s === undefined) s = 1;
    return Math.round(x / s) * s;
}

/**
 * Round down to the nearest multiple of a value. *
 * @param {Number} x The number to round
 * @param {Number} [s=1] The number to round to
 * @returns {number}
 */
export function floorN(x, s) {
    if (s === undefined) s = 1;
    return Math.floor(x / s) * s;
}
/**
 * Round down to the nearest multiple of a value. *
 * @param {Number} x The number to round
 * @param {Number} [s=1] The number to round to
 * @returns {number}
 */
export function ceilN(x, s) {
    if (s === undefined) s = 1;
    return Math.ceil(x / s) * s;
}

/**
 * Pad s with characters from pad until it is the length of pad. So, leftPad('000', n) will zero-pad n to 3 characters
 * @param {string} pad
 * @param {Number} s
 */
export function leftPad(pad, s) {
    return (pad + s).slice(-pad.length)
}

/**
 * Count how many decimal points a string representation of x has
 * @param {Number} x
 */
export function countDecimals(x) {
    if (x == null) return x;
    const s = String(x);
    const i = s.indexOf('.');
    return i < 0 ? 0 : s.length - i - 1;
}

/**
 * Format the argument with 1 decimal unless it is double digits, then drop the decimal
 * @param {Number} x
 * @returns {string}
 */
export function smallDecimal(x) {
    if (-0.05 < x && x < 0.05) {
        return '0';
    }
    if (-0.95 < x && x < 0.95) {
        return x.toFixed(1).substring(1);  // .3
    }
    if (-9.95 < x && x < 9.95) {
        return x.toFixed(1);  // 3.3
    }
    return x.toFixed(0);  // 33
}
